export const mobileMaxWidth = '(max-width: 767px)';
